var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5V3.5C18 3.22386 17.7761 3 17.5 3H16C15.7239 3 15.5 3.22386 15.5 3.5V6M9.51925 3.29698L5.37165 4.66955C4.55287 4.94051 4 5.70583 4 6.56828V18.25C4 19.3546 4.89543 20.25 6 20.25H18.5C19.6046 20.25 20.5 19.3546 20.5 18.25V10.4726C20.5 9.7864 20.1483 9.14821 19.5682 8.78174L11.2158 3.50489C10.7099 3.18525 10.0874 3.10897 9.51925 3.29698ZM8.5 11.25H10C10.2761 11.25 10.5 11.0261 10.5 10.75V9.25C10.5 8.97386 10.2761 8.75 10 8.75H8.5C8.22386 8.75 8 8.97386 8 9.25V10.75C8 11.0261 8.22386 11.25 8.5 11.25ZM17 20V13.5C17 13.2239 16.7761 13 16.5 13H14C13.7239 13 13.5 13.2239 13.5 13.5V20H17Z",
    stroke: "#5D697C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.1fe2eb9263b2e7dae7b479ec97014dab.svg";
export { ForwardRef as ReactComponent };